import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

export const HowItWorksOverview = () => {
  const { t, lp } = useI18n();
  return (
    <section className="py-12 lg:py-20" data-testid="how-overview">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between gap-6 mb-8 flex-wrap">
          <div>
            <div className="eyebrow mb-3">{t.nav.how}</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl text-white tracking-tight">{t.home.howGlanceTitle}</h2>
          </div>
          <Link
            to={lp("/how-it-works")}
            data-testid="how-overview-link"
            className="inline-flex items-center gap-1.5 text-cyan-300 hover:text-cyan-200 text-sm font-medium"
          >{t.home.seeHow} <ArrowRight size={13} /></Link>
        </div>
        <div className="grid md:grid-cols-3 gap-3">
          {t.home.howGlanceSteps.map((s) => (
            <div key={s.n} className="glass rounded-2xl p-6" data-testid={`how-overview-step-${s.n}`}>
              <div className="font-mono text-[11px] tracking-widest text-cyan-300 mb-3">{t.how.stepLabel} {s.n}</div>
              <h3 className="font-display font-bold text-white text-lg leading-snug">{s.title}</h3>
              <p className="text-slate-400 mt-2 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
